import React from 'react'
import Home from '../pages/home/Home';
import { useRoutes } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import AboutUs from '../pages/aboutUs/AboutUs';
import ContactUs from '../pages/contactUs/ContactUs';
import Faq from '../pages/faq/Faq';
import NotFound from '../pages/notFound/NotFound';
import Terms from '../pages/terms/Terms';
import PrivacyPolicy from '../pages/privacyPolicy/PrivacyPolicy';
import DeleteAccount from '../pages/deleteAccount/DeleteAccount';

const RouteContainer = () => {
    const routes = [
        {
            path: '/',
            element: <Home />
        },
        {
            path: '/about',
            element: <AboutUs />
        },
        {
            path: '/contact',
            element: <ContactUs />
        },
        {
            path: '/faq',
            element: <Faq />
        },
        {
            path: '/privacy',
            element: <PrivacyPolicy />
        },
        {
            path: '/terms',
            element: <Terms />
        },
        {
            path: '/delete-account',
            element: <DeleteAccount />
        },
        {
            path: '*',
            element: <NotFound />
        }
    ]
    return (
        <>
            <div className='bg-white text-slate-900 overflow-x-hidden'>
                <Header />
                {useRoutes(routes)}
                <Footer />
            </div>
        </>
    )
}

export default RouteContainer;